/* global $ */

import { gsap } from 'gsap';
import { viewportHeight } from '../helpers/dom-tools';

const TOCController = {
  $toc: [],
  $dots: [],
  $nav: [],
  $previousSection: [],
  $tocSections: [],
  $tocMBtn: [],
  $tocMBtnClose: [],
  state: {
    open: false,
  },

  /**
   * Collect elems and call bind.
   */
  init: function() {
    this.$toc = $('#prim-toc');
    this.$nav = $('.toc-nav');
    this.$dots = $('.toc-dots');
    this.$content = $('#capability-sections .scroll-side');
    this.$tocSections = $('.toc-section');
    this.$tocMBtn = $('#toc-mbtn');
    this.$tocMBtnClose = $('#toc-mbtn-close');
    this.$hexes = $('.sticky-side .hexagon');
    this.$hexesDecorative = $('.sticky-side .hex-decorative');
    this.$hexesLarge = $('.sticky-side .hex-large');
    this.$hexesSmall = $('.sticky-side .hex-small');

    // If primary elem does exist.
    if (this.$toc.length) {
      this.bind();
    }
  },

  /**
   * Bind event handlers.
   */
  bind: function() {
    this.handleDotsHover();
    this.handleMobileBtn();
    this.handleMobileClick();

    this.intersect();

    document.addEventListener('keyup', (ev) => {
      if (ev.keyCode === 27 && this.state.open === true) {
        this.handleClose();
      }
    });

    this.handleResize();
  },

  /**
   * Handle GSAP Timeline.
   */
  handleClose: function() {
    if (this.state.open === true) {
      gsap.fromTo(
        this.$nav,
        {
          x: '0%',
        },
        {
          x: () => $('.toc-nav').width() * -1,
          duration: 0.5,
          ease: 'power4',
          onComplete: () => {
            gsap.to(this.$nav, {
              autoAlpha: 0,
              duration: 0,
            });
            this.$toc.removeClass('temp-highest-z');
          },
        },
      );
      this.state.open = false;
    }
  },

  /**
   * Handle GSAP Timeline.
   */
  handleOpen: function() {
    if (this.state.open === false) {
      this.$toc.addClass('temp-highest-z');
      gsap.fromTo(
        this.$nav,
        {
          autoAlpha: 0,
          x: () => $('.toc-nav').width() * -1,
        },
        {
          autoAlpha: 1,
          x: '0%',
          duration: 0.5,
          ease: 'power4',
        },
      );
      this.state.open = true;
    }
  },

  /**
   * Handle Resize values
   */
  handleResize: function() {
    $(window).resize(() => {
      this.handleViewportHeight();
    });
  },

  /**
   * Update viewport height on wrapper to handle IOS bugs.
   */
  handleViewportHeight: function() {
    const h = viewportHeight();
    this.$toc.css('height', h);
  },

  /**
   * Handle Mobile btn toggle.
   *
   */
  handleMobileBtn: function() {
    this.$tocMBtn.on('click', (e) => {
      e.preventDefault();
      this.handleOpen();
    });

    this.$tocMBtnClose.on('click', (e) => {
      e.preventDefault();
      this.handleClose();
    });
  },

  /**
   * Handle Mobile Item Click.
   */
  handleMobileClick: function() {
    if (this.$tocMBtnClose.is(':visible')) {
      $('.toc__item a', this.$nav).on('click', () => this.handleClose());
    }
  },

  /**
   * Desktop hover state.
   */
  handleDotsHover: function() {
    // Prevent click.
    $('.toc-dots__item', this.$dots).on('click', (e) => e.preventDefault());

    // Handle hover.
    this.$dots.on('mouseover', () => this.handleOpen());
    this.$nav.on('mouseleave', () => this.handleClose());
  },

  /**
   * Set toc to active.
   */
  setTocActive: function() {
    const $firstActive = this.$content.find('.toc-active').eq(0);
    let id;

    if ($firstActive.length) {
      id = $firstActive.closest('.toc-section').attr('data-section-id');
    } else if (this.$previousSection) {
      id = $(this.$previousSection)
        .closest('.toc-section')
        .attr('data-section-id');
    }

    if (id) {
      $('a', this.$dots).removeClass('toc-active');
      $('a', this.$nav).removeClass('toc-active');
      $('.dynamic', this.$hexes).removeClass('toc-active');
      $('.dynamic', this.$hexesDecorative).removeClass('toc-active');
      $('.dynamic', this.$hexesLarge).removeClass('toc-active');
      $('.dynamic', this.$hexesSmall).removeClass('toc-active');
      $(`a[data-toc="${id}"]`)
        .addClass('toc-active')
        .get(0);
      $(`.dynamic[data-toc="${id}"]`)
        .addClass('toc-active')
        .get(0);
      // $(this.$toc).addClass('toc-is-supremely-active');
    }
  },

  /**
   * Identify Intersections.
   */
  intersect: function() {
    window.addEventListener('DOMContentLoaded', () => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const { target, isIntersecting } = entry;
            const $entry = $(target);
            if (isIntersecting && !$entry.hasClass('toc-active')) {
              $entry.addClass('toc-active');
              this.$previousSection = $entry;
            } else {
              $entry.removeClass('toc-active');
            }
            this.setTocActive();
          });
        },
        {
          rootMargin: '56px 0px 20px 0px',
          threshold: [0.2],
        },
      );

      this.$tocSections.each((i, section) => {
        observer.observe(section);
      });

      const capabilitiesObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              document
                .getElementById('prim-toc')
                .classList.add('toc-is-visible');
            } else {
              document
                .getElementById('prim-toc')
                .classList.remove('toc-is-visible');
            }
          });
        },
        {
          rootMargin: '-45% 0px 0px 0px',
        },
      );
      capabilitiesObserver.observe(
        document.querySelector('.capabilities-section'),
      );
    });
  },
};

TOCController.init();
